import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserInterests, acceptInterestRequest, declineInterestRequest } from "../services/interestService";

// fetch user interests
export const fetchUserInterests = createAsyncThunk(
  "interests/fetch",
    async () => {
      const interests = await getUserInterests();
      return interests;
    }
);

//accept interest request
export const acceptInterest = createAsyncThunk(
  "interests/accept",
  async (id) => {
    const response = await acceptInterestRequest(id);
    return response;
  }
);

//decline interest request
export const declineInterest = createAsyncThunk(
  "interests/decline",
  async (id) => {
    const response = await declineInterestRequest(id);
    return response;
  }
);

const interestSlice = createSlice({
  name: "interests",
  initialState: {
    data: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInterests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserInterests.fulfilled, (state, action) => {
        console.log("Fetched interests:", action.payload);
        
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserInterests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { interest } = interestSlice.actions;
export default interestSlice.reducer;
